import React from 'react';
import ErrorBoundary from '@/ErrorBoundary';
// import {vendorB4login} from '@/config';

import Header from '@/views/Layout/internal/Header';
import Footer from '@/views/Layout/internal/Footer';

// revenue
import InternalRouterSwitch from '@/internal/Routes';

// <link rel='stylesheet' href={`${vendorB4login}/css/all.css`} />

const LoginPage = ({children}) => (
  <>
    <ErrorBoundary>
      <main className='container'>{children}</main>
    </ErrorBoundary>
  </>
);

const Internal = ({match}) => (
  <>
    <Header />
    <ErrorBoundary>
      <main className='container internal'>
        <InternalRouterSwitch match={match} />
      </main>
    </ErrorBoundary>
    <Footer />
  </>
);
export {LoginPage, Internal};
